<template>
  <div class="" id="search" style="">
    <section id="search-result">

      <div class="contact search">
        <div class="search-header">
          <h3 class="name">{{ str }}</h3>
          <h3 class="results-text"> {{ $t('Video.search.searchresult') }}</h3>
        </div>
        <div v-show="searchData.length == 0" class="row">
          <div class="col nullmsg">{{ resultMsg }}</div>
        </div>
        <div class="event" v-if="(tp == 99 || tp == 1) && showSearchData(1).length !== 0">
          <h5> {{ $t('Video.search.eventresult') }}</h5>
          <div
            v-for="(item, idx) in showSearchData(1, (showMore ? pageParams.MaxResultCount : MoreQuery.event) * pageParams.currentPage)"
            :key="idx">
            <a :href="item.url" class="event-link">
              <div class="post-box">
                <div :class="StatusClass(item.statusF)" v-if="item.statusF !== null">{{ item.statusF }}</div>
                <p class="post-title" v-html="item.title"></p>
                <div class="event-info">
                  <p class="post-information">活動日期: {{ item.createTimeI }}</p>
                  <p class="post-information">舉辦地點: {{ item.address }}</p>
                </div>
              </div>
            </a>
          </div>
          <div class="search-all">
            <button @click="searchMore(1)">{{ NOMORE ? '暫無更多' : $t('Video.search.searchMore') }}</button>
            <span class="line"></span>
          </div>
        </div>

        <div class="album" v-if="(tp == 99 || tp == 2) && showSearchData(2).length !== 0">
          <h5> {{ $t('Video.search.albumresult') }}</h5>
          <div uk-slider v-if="!showMore">
            <div class="uk-position-relative">
              <div class="uk-slider-container">
                <ul class="uk-slider-items uk-child-width-1-2 uk-child-width-1-4@m uk-grid">
                  <!-- album - 1 -->
                  <li
                    v-for="(item, idx) in showSearchData(2, (showMore ? pageParams.MaxResultCount : MoreQuery.album) * pageParams.currentPage)"
                    :key="idx">
                    <a :href="item.url">
                      <div class="card" style="width: 18rem;">
                        <div class="album">
                          <img :src="item.photoUrl" class="card-img-top" alt="...">
                          <div class="album-photo-count">
                            <span>{{ item.photoCount }}</span>
                          </div>
                        </div>
                        <div class="card-body album-info">
                          <p class="card-text album-name" v-html="item.title"></p>
                          <p class="album-user"><router-link
                              :to="{ name: 'customerPublishLook', query: { authorId: item.sgL_Mem_Cid } }" >
                              {{ item.displayName }}
                             </router-link>
                          </p>
                          <p class="album-upload-date">{{ item.createTimeI }}</p>
                        </div>
                      </div>
                    </a>
                  </li>
                </ul>

              </div>
              <a class="uk-position-center-right-out" href="#" uk-slider-item="next"><i
                  class="fas fa-arrow-right bi-arrow-right" /></a>
            </div>
          </div>
          <div class="album" v-else>
            <div class="uk-child-width-1-2 uk-child-width-1-4@m uk-grid">
              <div
                v-for="(item, idx) in showSearchData(2, (showMore ? pageParams.MaxResultCount : MoreQuery.album) * pageParams.currentPage)"
                :key="idx">
                <div class="album-box">
                  <a :href="item.url">
                    <div class="card" style="width: 18rem;">
                      <div class="album">
                        <img :src="item.photoUrl" class="card-img-top" alt="...">
                        <div class="album-photo-count">
                          <span>{{ item.photoCount }}</span>
                        </div>
                      </div>
                      <div class="card-body album-info">
                        <p class="card-text album-name" v-html="item.title"></p>
                        <p class="album-user"><router-link
                            :to="{ name: 'customerPublishLook', query: { authorId: item.sgL_Mem_Cid } }" >
                            {{ item.displayName }}
                          </router-link>
                        </p>
                        <p class="album-upload-date">{{ item.createTimeI }}</p>
                      </div>
                    </div>
                  </a>
                </div>
              </div>

            </div>
          </div>

          <div class="search-all">
            <button @click="searchMore(2)">{{ NOMORE ? '暫無更多' : $t('Video.search.searchMore') }}</button>
            <span class="line"></span>
          </div>
        </div>

        <div class="topic" v-if="(tp == 99 || tp == 0) && showSearchData(0).length !== 0">
          <h5> {{ $t('Video.search.topicresult') }}</h5>
          <!-- Topic 1 -->
          <div class="topic-info divresult"
            v-for="(item, idx) in showSearchData(0, (showMore ? pageParams.MaxResultCount : MoreQuery.topic) * pageParams.currentPage)"
            :key="idx">
            <a :href="item.url">
              <h3 class="post-title" v-html="item.title"></h3>
              <p class="post-information content" v-html="item.content"></p>
            </a>
          </div>
          <!-- ./Topic 1 -->

          <!-- Topic 2 -->

          <!-- ./Topic 5 -->
          <div class="search-all">
            <button @click="searchMore(0)">{{ NOMORE ? '暫無更多' : $t('Video.search.searchMore') }}</button>
            <span class="line"></span>
          </div>
        </div>

        <div class="video" v-if="(tp == 99 || tp == 3) && showSearchData(3).length !== 0">
          <h5> {{ $t('Video.search.videoresult') }}</h5>
          <div uk-slider v-if="!showMore">
            <div class="uk-position-relative">
              <div class="uk-slider-container">
                <ul class="uk-slider-items uk-child-width-1-2 uk-child-width-1-4@m uk-grid">
                  <!-- video - 1 -->
                  <li
                    v-for="(item, idx) in showSearchData(3, (showMore ? pageParams.MaxResultCount : MoreQuery.video) * pageParams.currentPage)"
                    :key="idx">
                    <a :href="item.url">
                      <div class="card" style="width: 18rem;">
                        <div class="album">
                          <img :src="item.imageFileP" class="card-img-top" alt="...">
                          <!-- <el-image :src="item.imageFileP">
                            <div slot="error" class="image-slot">
                              <i class="el-icon-picture-outline"></i>
                            </div>
                          </el-image> -->
                          <div class="video-duration">
                            <span>{{ item.mov_VSourceTimeFormat }}</span>
                          </div>
                        </div>
                        <div class="card-body album-info">
                          <p class="card-text album-name" v-html="item.title"></p>
                          <p class="album-user"><router-link
                              :to="{ name: 'customerPublishLook', query: { authorId: item.sgl_Mem_Cid } }" >
                              {{ item.displayName }}
                            </router-link>
                          </p>
                          <p class="album-upload-date">{{ item.createTimeI }}</p>
                        </div>
                      </div>
                    </a>
                  </li>
                </ul>
              </div>
              <a class="uk-position-center-right-out" href="#" uk-slider-item="next"><i
                  class="fas fa-arrow-right bi-arrow-right" /></a>
            </div>
          </div>
          <div class="uk-child-width-1-2 uk-child-width-1-4@m uk-grid" v-else>
            <!-- video - 1 -->
            <div
              v-for="(item, idx) in showSearchData(3, (showMore ? pageParams.MaxResultCount : MoreQuery.video) * pageParams.currentPage)"
              :key="idx">
              <div class="video-box">
                <a :href="item.url">
                  <div class="card" style="width: 18rem;">
                    <div class="album">
                      <img :src="item.imageFileP" class="card-img-top" alt="...">
                      <div class="video-duration">
                        <span>{{ item.mov_VSourceTimeFormat }}</span>
                      </div>
                    </div>
                    <div class="card-body album-info">
                      <p class="card-text album-name" v-html="item.title"></p>
                      <p class="album-user"><router-link
                          :to="{ name: 'customerPublishLook', query: { authorId: item.sgl_Mem_Cid } }">
                         {{ item.displayName}}
                        </router-link>
                      </p>
                      <p class="album-upload-date">{{ item.createTimeI }}</p>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
          <div class="search-all">
            <button @click="searchMore(3)">{{ NOMORE ? '暫無更多' : $t('Video.search.searchMore') }}</button>
            <span class="line"></span>
          </div>
        </div>

        <div class="blog" v-if="(tp == 99 || tp == 5) && showSearchData(5).length !== 0">
          <h5> {{ $t('Video.search.blogresult') }}</h5>
          <!-- Blog 1 -->
          <div class="blog-info divresult"
            v-for="(item, idx) in showSearchData(5, (showMore ? pageParams.MaxResultCount : MoreQuery.blog) * pageParams.currentPage)"
            :key="idx">
            <a :href="item.url">
              <h3 class="post-title" v-html="item.title"></h3>
              <p class="post-information content" v-html="item.content">
              </p>
            </a>
          </div>
          <!-- ./Blog 1 -->



          <div class="search-all">
            <button @click="searchMore(5)">{{ NOMORE ? '暫無更多' : $t('Video.search.searchMore') }}</button>
            <span class="line"></span>
          </div>
        </div>

        <div class="story" v-if="(tp == 99 || tp == 4) && showSearchData(4).length !== 0">
          <h5> {{ $t('Video.search.storyresult') }}</h5>
          <div uk-slider v-if="!showMore">
            <div class="uk-position-relative">
              <div class="uk-slider-container">
                <ul class="uk-slider-items uk-child-width-1-2 uk-child-width-1-4@m uk-grid">
                  <!-- Story - 1 -->
                  <li
                    v-for="(item, idx) in showSearchData(4, (showMore ? pageParams.MaxResultCount : MoreQuery.story) * pageParams.currentPage)"
                    :key="idx">
                    <a :href="item.url">
                      <div class="card" style="width: 18rem;">
                        <div class="story-img">
                          <img :src="item.sgL_ImageLogo" class="card-img-top" alt="...">
                          <div class="video-duration">
                            <span><i class="fa fa-eye" aria-hidden="true"></i> {{ item.photoCount ? item.photoCount :
                              0 }}</span>
                          </div>
                        </div>
                        <div class="card-body story-info">
                          <p class="card-text album-name" v-html="item.title"></p>
                          <p class="album-user"><router-link
                              :to="{ name: 'customerPublishLook', query: { authorId: item.sgl_Mem_Cid } }">
                              {{ item.displayName }}
                            </router-link>
                          </p>
                          <p class="album-upload-date">{{ $relativeTime(item.createTime) }}</p>
                        </div>
                      </div>
                    </a>
                  </li>
                </ul>
              </div>
              <a class="uk-position-center-right-out" href="#" uk-slider-item="next"><i
                  class="fas fa-arrow-right bi-arrow-right" /></a>
            </div>
          </div>
          <div class="uk-child-width-1-2 uk-child-width-1-4@m uk-grid" v-else>
            <!-- Story - 1 -->
            <div
              v-for="(item, idx) in showSearchData(4, (showMore ? pageParams.MaxResultCount : MoreQuery.story) * pageParams.currentPage)"
              :key="idx" class="mb-4">
              <div class="story-box">
                <a :href="item.url">
                  <div class="card" style="width: 18rem;">
                    <div class="story-img">
                      <img :src="item.sgL_ImageLogo" class="card-img-top" alt="...">
                      <div class="video-duration">
                        <span><i class="fa fa-eye" aria-hidden="true"></i> {{ item.photoCount ? item.photoCount :
                          0 }}</span>
                      </div>
                    </div>
                    <div class="card-body story-info">
                      <p class="card-text album-name" v-html="item.title"></p>
                      <p class="album-user"><router-link
                          :to="{ name: 'customerPublishLook', query: { authorId: item.sgl_Mem_Cid } }" >
                          {{ item.displayName }}
                      </router-link>
                      </p>
                      <p class="album-upload-date">{{ $relativeTime(item.createTime) }}</p>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
          <div class="search-all">
            <button @click="searchMore(4)">{{ NOMORE ? '暫無更多' : $t('Video.search.searchMore') }}</button>
            <span class="line"></span>
          </div>
        </div>

      </div>
      <div class="col-md-4 col-xs-12" style="text-align: center">
        <N1Vue> </N1Vue>
      </div>

    </section>
  </div>
</template>
<script>
import N1Vue from "../Ad/N1.vue";

export default {
  components: {
    N1Vue,
  },
  data () {
    return {
      str: "",
      tp: 99,
      imgUrl: require("../../assets/images/album/upload-loading.jpg"),
      searchData: [],
      resultMsg: "",
      showMore: false,
      NOMORE: false,
      MoreQuery: {
        topic: 5,
        event: 3,
        album: 12,
        video: 12,
        blog: 2,
        story: 12,
      },
      pageParams: {
        currentPage: 1,
        limit: 12,
      },
    };
  },
  created () {
    if (this.$route.query && this.$route.query.q) {
      this.str = this.$route.query.q;
      this.tp = this.$route.query.type;
    }
    if (!this.IsNullOrEmpty(this.str)) {
      this.search();
    }
  },
  computed: {

    showSearchData () {
      return function (type, index = 12) {
        let searchData = []
        this.searchData.forEach((item) => {
          if (item.type == type) {
            searchData = item.searchResponseList
          }
        })
        if (searchData.length > index) {
          return searchData.slice(0, index);
        }
        return searchData;
      }
    },
    StatusClass () {
      return function (status) {
        return {
          'event-situation': true,
          'uk-label': true,
          'uk-label-warning': status == "尚未開始",
          'uk-label-success': status == "報名中",
          'uk-label-danger': status == "結束報名",
          '': status == "賽事延期",
          'uk-label-grey': status == "賽事取消",
        }
      };
    },
  },
  methods: {
    async searchMore (type) {
      if (!this.showMore) {
        this.tp = type;
        this.showMore = true;
        return;
      }
      if (this.NOMORE) return;

      this.pageParams.currentPage += 1;
      let params = {
        Title: this.str,
        Type: this.tp,
        SkipCount: (this.pageParams.currentPage - 1) * this.pageParams.limit, //从第几条开始查，
        MaxResultCount: this.pageParams.limit, //查多少条
      };
      const { data: res } = await this.$api.common.SiteSearch(params);
        let that = this;
      if (res.success) {
        if (res.result[0].searchResponseList.length == 0) { this.NOMORE = true; return; }
        res.result.forEach((item, ix, arr) => {
          if (item.type == 0 || item.type == 5) {
            item.searchResponseList.forEach((e, idx) => {
              let div = document.createElement("div");
              div.innerHTML = e.content;
              res.result[ix].searchResponseList[idx].content = div.innerText
                .replace(/<style[^>]*?>[\s\S]*?<\/style>/ig, '')
                .replace(/<\/?.+?>/g, "")
                .replace(/ /g, "")
                .replace(/<[^>]+>/g, '').replace(that.str, `<span style="color:red">${that.str}</span>`);
                res.result[ix].searchResponseList[idx].content = that.replacementCharacter (res.result[ix].searchResponseList[idx].content,that.str);
              if (e.title)
                res.result[ix].searchResponseList[idx].title = that.replacementCharacter (e.title, that.str);
              if (e.displayName)
                res.result[ix].searchResponseList[idx].displayName = that.replacementCharacter (e.displayName, that.str);
            })

          }
        });
        this.searchData[this.getSearchIndex(this.tp, this.searchData)].searchResponseList.push(...res.result[0].searchResponseList);
      } else {
        this.$message({ type: "error", message: res.error.message });
      }
    },
    getSearchIndex (type, array) {
      let index = 0;
      array.forEach((item, idx) => {
        if (item.type == type) index = idx;
      })
      return index;
    },
    replacementCharacter  (str, searchValue) {
      const regex = new RegExp(searchValue, 'gi');
      return str.replace(regex, (match) => {
        const firstChar = match;
        return  `<span style="color:red">${firstChar}</span>`;
      });
    },
    search () {
      this.searchData = [];
      let that = this;
      let params = {
        Title: this.str,
        Type: this.tp,
        SkipCount: (this.pageParams.currentPage - 1) * this.pageParams.limit, //从第几条开始查，
        MaxResultCount: this.pageParams.limit, //查多少条
      };
      this.resultMsg = "搜索中...";

      this.$api.common.SiteSearch(params).then((res) => {
        if (res.data.success) {
          if (res.data.result.length == 0) {
            this.resultMsg = "0 條結果";
          } else {
            res.data.result.forEach((item, ix, arr) => {
              item.searchResponseList.forEach((e, idx) => {
                let div = document.createElement("div");
                div.innerHTML = e.content;
                res.data.result[ix].searchResponseList[idx].content = div.innerText
                  .replace(/<style[^>]*?>[\s\S]*?<\/style>/ig, '')
                  .replace(/<\/?.+?>/g, "")
                  .replace(/ /g, "")
                  .replace(/<[^>]+>/g, '')
                  .replace(that.str, `<span style="color:red">${that.str}</span>`);
                  res.data.result[ix].searchResponseList[idx].content = that.replacementCharacter (res.data.result[ix].searchResponseList[idx].content,that.str);
                if (e.title)
                  res.data.result[ix].searchResponseList[idx].title =that.replacementCharacter (e.title, that.str);
                if (e.displayName)
                 res.data.result[ix].searchResponseList[idx].displayName = that.replacementCharacter (e.displayName, that.str);
              
              })
            });

            this.searchData =  res.data.result;
          }
        } else {
          this.resultMsg = "0 條結果";
          this.$message({ type: "error", message: res.data.error.message });
        }
      }).catch((err) => {
         this.resultMsg = "0 條結果";
          this.$message({ type: "error", message: err });
      });
      
    },
  },
};
</script>
<style>
:focus:not([tabindex^='-']) {
  outline: none !important;
  outline-offset: unset !important;
}

.form-control:focus {
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
</style>
<style scoped>
.image-slot,
.el-image .image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  color: #909399;
  font-size: 18px;
}

/* ./Style 4 */
/* searchcopy css*/
@media (max-width: 767.98px) {
  .contact.search {
    width: 100%;
    margin-top: 10px !important;
    padding: 20px !important;
  }

  .uk-slider-items {
    width: calc(100% - 50px) !important;
  }

  .event .post-title {
    font-size: 18px !important;
  }

  .event-info p {
    margin: 10px 10px 0 0 !important;
  }

}

.card-body {
  padding: 10px;
}

.search-header {
  display: flex;
}

.divresult .content {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: 20px 0 20px 0;
}

.toast-body {
  color: #fff;
}


#searchModal .select-options {
  padding-left: 0px;
  margin-top: 0px;
}

.hidtory-toast:hover {
  background: #198754;
}

.search .uk-grid+.uk-grid {
  margin-top: 0px;
}

:focus-visible {
  outline: none !important;
}


.search a {
  color: #333;
}

.search a:hover {
  color: #198654;
}

.contact.search {
  width: 100%;
  margin-top: 100px;
  padding: 50px;
}

.contact.search a:hover {
  text-decoration: none;
}


.search h3 {
  margin: 0 10px 0 0;
}

.search h5 {
  margin: 20px 0 15px 0;
  font-size: 18px;
  color: #198654;
  font-weight: 600;
}

.post-box {
  margin-bottom: 10px;
  padding: 20px;
  border-radius: 10px;
  border: 1px #e3e3e3 solid;
  background: #fff;
  color: #333;
}

.post-title {
  font-size: 24px;
}

.card {
  width: fit-content !important;
}


/* Search Button */
.search-all button {
  padding: 10px 20px;
  border: 1px #e7e0e0 solid;
  border-radius: 50px;
  color: #333;
  width: 250px;
  min-width: 30%;
  font-size: 17px;
  font-weight: 600;
  letter-spacing: 1px;
}

.search-all {
  text-align: center;
  margin: 20px 0 60px 0px;
}

.line {
  width: 100%;
  display: block;
  border: 1px #e7e7e7 solid;
  margin-top: -22px;
}

.search-all button:hover {
  background: #e7e7e7;
}

/* ./Search Button */

/* Event */
.event-link:hover>.post-box {
  background: #e7e7e7;
}

.event-info {
  display: flex;
  align-items: center;
}

.event-info p {
  margin: 10px 50px 0 0;
}

.post-title {
  margin-bottom: 5px;
  font-size: 22px;
  color: #333;
  font-weight: 700;
}

.uk-label-grey {
  background: #333 !important;
}

/* ./Event */

/* Album */
.uk-slider-items {
  width: calc(100% - 160px);
}

.album,
.video-image {
  position: relative;
  overflow: hidden;
}

.card-text.album-name {
  font-size: 18px;
}

.card-body.album-info>p {
  margin: 0 0 5px 0;
}


.search .uk-slider {
  margin-right: 55px;
}

.search .bi-arrow-right {
  margin: 10px;
  font-size: 25px;
  color: #333;
  display: grid;
  width: 45px;
  height: 45px;
  align-items: center;
  justify-content: center;
}


.search .bi-arrow-right:hover {
  background: #e7e7e7;
  border-radius: 50%;
}


.album li {
  background: #f8f9fa;
  padding: 0;
  margin-left: 40px;
  border: #efefef 2px solid;
  border-radius: 2px;
}

li:hover .album img {
  -webkit-transform: scale(1.04);
  transform: scale(1.04);
  -webkit-transition: all 1s ease;
  transition: all 1s ease;
}

.album>.uk-grid>div {
  margin-bottom: 20px;
}


.album-box {
  background: #f8f9fa;
  border: #efefef 2px solid;
  border-radius: 2px;
  height: 100%;
}

.card,
.card-body {
  border: none;
  background: transparent !important;
  box-shadow: none !important;
}


/* ./Album */

/* Video */

.video li {
  background: #f8f9fa;
  padding: 0;
  margin-left: 40px;
  border: #efefef 2px solid;
  border-radius: 2px;
}

.video>.uk-grid>div {
  margin-bottom: 20px;
}


.video-box {
  background: #f8f9fa;
  border: #efefef 2px solid;
  border-radius: 2px;
  height: 100%;
}

/* ./Video */


/* Topic */
a:hover>.post-title {
  color: #198654;
}

a:hover>.post-information {
  color: #333;
}

.topic-info {
  margin-bottom: 40px;
  padding-bottom: 5px;
  border-bottom: #dee2e6 1px solid;
}

.topic>div:nth-last-child(2),
.topic-search .top div:last-child,
#toggle-topic div:last-child {
  margin-bottom: 0px;
  padding-bottom: 0px;
  border-bottom: none !important;
}

/* ./Topic */


/* Blog */
.blog-info {
  margin-bottom: 40px;
  padding-bottom: 5px;
  border-bottom: #dee2e6 1px solid;
}

.blog>div:nth-last-child(2),
.blog-search>div:last-child {
  margin-bottom: 0px;

  padding-bottom: 0px;
  border-bottom: none !important;
}


/* ./Blog */


/* Story */
.story li {
  background: #f8f9fa;
  padding: 0;
  margin-left: 40px;
  border: #efefef 2px solid;
  border-radius: 2px;
}

.story p {
  margin: 0px;
}

.story .card {
  min-width: 100%;
}

.story-box {
  background: #f8f9fa;
  border: #efefef 2px solid;
  border-radius: 2px;
  height: 100%;
}

.story-img {
  height: 114px;
  background: #000;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}


.story-img img {
  height: fit-content;
  width: auto;
  max-height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/Video/search.vue